import React from 'react';
import { FaTimes, FaBan, FaUserShield } from 'react-icons/fa';

const AutoTradeDisabledModal = ({
  isOpen,
  onClose,
  reason,
  ctaLabel = null,
  onCtaClick = null,
}) => {
  if (!isOpen) return null;

  const message =
    reason ||
    'Automated trading is currently disabled. Please contact the administrator if you believe this is a mistake.';

  const lower = message.toLowerCase();
  const isGlobal = lower.includes('for all users');
  const isMarketClosed =
    lower.includes('market is closed') ||
    lower.includes('only available during market hours') ||
    lower.includes('market has closed');

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full animate-fade-in">
        {/* Header */}
        <div className="relative bg-gradient-to-r from-red-600 to-pink-600 text-white px-6 py-5 rounded-t-xl">
          <h2 className="text-xl font-bold pr-8">
            {isMarketClosed
              ? 'Market Closed - Automated Trading Unavailable'
              : isGlobal
              ? 'Automated Trading Disabled by Admin'
              : 'Automated Trading Disabled for Your Account'}
          </h2>
          <button
            onClick={onClose}
            className="absolute top-5 right-5 text-white hover:text-gray-200 transition-colors"
          >
            <FaTimes className="text-xl" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center">
              {isMarketClosed || isGlobal ? (
                <FaBan className="text-4xl text-red-500" />
              ) : (
                <FaUserShield className="text-4xl text-orange-500" />
              )}
            </div>
          </div>

          {/* Message */}
          <p className="text-center text-gray-700 mb-4 text-base">{message}</p>

          <p className="text-center text-sm text-gray-500 mb-6">
            You can still view signals and charts.
            {!isMarketClosed && (
              <>
                {' '}
                To enable automated trading, please reach out to support or your administrator.
              </>
            )}
          </p>

          {/* Close Button */}
          <div className="space-y-3">
            {ctaLabel && onCtaClick && (
              <button
                onClick={onCtaClick}
                className="w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                {ctaLabel}
              </button>
            )}
            <button
              onClick={onClose}
              className="w-full bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Got It
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoTradeDisabledModal;

